export const BASE_URL = "https://www.wonda.sh";

// Cache-busting version for dynamically generated OG images. Bump to force the
// CDN/edge to serve freshly rendered cards instead of stale 7-day-cached PNGs.
export const OG_VERSION = "3";

export const SOCIAL_LINKS = {
  twitter: "https://x.com/wonda_sh",
  github: "https://github.com/degausai/wonda",
  linkedin: "https://www.linkedin.com/company/wondash/",
  instagram: "https://www.instagram.com/wonda.sh/",
} as const;
